// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Vetting20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Vetting20Filled: FC<Vetting20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path
                d="M8.145 2.448a2.328 2.328 0 0 1 3.71 0 2.329 2.329 0 0 0 2.174.899 2.33 2.33 0 0 1 2.624 2.625 2.33 2.33 0 0 0 .9 2.173 2.329 2.329 0 0 1 0 3.71 2.33 2.33 0 0 0-.9 2.174 2.329 2.329 0 0 1-2.624 2.624 2.33 2.33 0 0 0-2.173.9 2.329 2.329 0 0 1-3.711 0 2.33 2.33 0 0 0-2.173-.9 2.33 2.33 0 0 1-2.625-2.624 2.329 2.329 0 0 0-.9-2.173 2.328 2.328 0 0 1 0-3.711 2.329 2.329 0 0 0 .9-2.173 2.33 2.33 0 0 1 2.625-2.625 2.329 2.329 0 0 0 2.173-.9Zm.793 8.427-1.772-1.75-1.062 1.063L8.938 13l4.958-4.937L12.833 7l-3.895 3.875Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Vetting20Filled;
